import React from 'react';
import { Colors, Metrics } from '../../themes';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import SvgIcon from '../../icons/SvgIcon';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '../common/Table';

const useStyles = makeStyles((theme) => {
  return {
    editTagContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowWrap: 'break-word',
      minWidth: 450,
      [theme.breakpoints.down(450)]: {
        minWidth: 300,
      },
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    errorDisplay: {
      color: Colors.errorRed,
    },
    content: {},
    footerButtonsContainer: {
      minHeight: 80,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      borderRadius: '4px 4px 0 0',
      padding: theme.spacing(4),
      [theme.breakpoints.down(Metrics.minWidth)]: {
        padding: theme.spacing(2),
        justifyContent: 'flex-start',
      },
      [theme.breakpoints.between('sm', 'lg')]: {
        padding: theme.spacing(2),
        minHeight: 60,
      },
    },
    button: {
      fontSize: 14,
      color: Colors.black,
      border: `1px solid ${Colors.disabledGrey}`,
      '&:hover': {
        background: Colors.disabledGrey,
        color: Colors.white,
      },
    },
    saveButton: {
      marginLeft: theme.spacing(1),
      fontSize: 14,
      color: Colors.white,
      background: Colors.blue,
      border: 'none',
      '&:hover': {
        background: Colors.lightBlue,
      },
    },
    lightTheme: {
      '& .MuiCheckbox-root': {
        color: Colors.disabledGrey,
      },
      '& .MuiCheckbox-root.Mui-checked': {
        color: Colors.blue,
      },
    },
  };
});

const SelectSitesCheckAllModal = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { onClose, onClickSave, saveButtonDisabled, selectAtLeastOneSiteError, checkedArray } = props;

  return (
    <div className={classes.editTagContainer}>
      <div className={classes.header}>
        <Typography variant="h2" id="modal-title">
          {t('widgetInOutCounter_selectSites')}
        </Typography>
        <IconButton key="close" aria-label="close" color="inherit" onClick={props.onClose}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      </div>
      {selectAtLeastOneSiteError && <div className={classes.errorDisplay}>{t('monitoring.selectAtLeastOneSite')}</div>}
      <div className={classes.content}>
        {props.showSelectAll && (
          <div className={classes.lightTheme}>
            <Checkbox
              checked={props.isSelectAllSitesButtonChecked}
              inputProps={{ 'aria-labelledby': 'check-all-sites' }}
              onChange={props.changeSelectAllSitesButton}
            />
            <span className={classes.checkAllLabel}>{t('Global_selectAll')}</span>
          </div>
        )}
        <Table lightTheme color={Colors.white} blue={Colors.blue} {...props} />
      </div>
      <div className={classes.footerButtonsContainer}>
        <Button type="button" variant="outlined" className={classes.button} onClick={onClose}>
          {t('Global_cancel')}
        </Button>
        <Button
          type="submit"
          variant="contained"
          className={classes.saveButton}
          onClick={onClickSave}
          endIcon={<SvgIcon icon="Save" width={20} color={saveButtonDisabled ? Colors.disabledGrey : Colors.white} />}
          disabled={saveButtonDisabled}
        >
          {t('Global_save')}
        </Button>
      </div>
    </div>
  );
};

export default SelectSitesCheckAllModal;
